<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-remove"></i> Users</span>
        <el-button icon="el-icon-plus" style="float: right;padding: 0" type="text" @click="showDialog('add')">Create User Restrict</el-button>
      </div>
      <div>
        <data-tables v-loading="loading" :data="restrictList" border :page-size="50" :pagination-props="{ background: true, pageSizes: [50, 100] }">
          <el-table-column prop="uid2" label="Member Code" header-align="center" align="center"></el-table-column>
          <el-table-column prop="restricttoAndbelow" label="Role" header-align="center" align="center"></el-table-column>
          <el-table-column prop="uid" label="Action" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="warning" size="mini" @click="showDialog('edit', scope.row.uid)">Edit</el-button>
              <el-button icon="el-icon-delete" type="danger" size="mini" @click="deleteRestrict(scope.row.uid)">Del</el-button>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </el-card>

    <el-dialog :title="title" :visible.sync="dialogRestrict" :close-on-click-modal="false">
      <el-form :model="formData" ref="formRestrict" label-width="150px" size="small" :rules="formDataRules" >
        <el-form-item label="Member Code" prop="uid2">
          <el-input v-model="formData.uid2" :disabled="action==='edit'"></el-input>
        </el-form-item>
        <el-form-item label="Restrict to (and under)" prop="restricttoAndbelow">
          <el-select v-model="formData.restricttoAndbelow" placeholder="Select Role">
            <el-option label="Super Admin" value="superadmin"></el-option>
            <el-option label="Admin" value="admin"></el-option>
            <el-option label="User" value="user"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="submiting" type="primary" @click="submitRestrict()">Submit</el-button>
        <el-button @click="dialogRestrict = false">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRestrictList, getRestrict, createRestrict, updateRestrict, deleteRestrict } from '@/api/customer'
export default {
  data() {
    return {
      loading: false,
      submiting: false,
      dialogRestrict: false,
      action: '',
      title: '',
      restrictList: [],
      formData: {
        uid: '',
        uid2: '',
        restricttoAndbelow: 'user',
      },
      formDataRules: {
        uid2: [
          { required: true, message: 'Please input member code', trigger: 'blur' },
        ],
      }
    }
  },
  methods:{
    getRestrictList(){
      this.loading = true
      getRestrictList().then(({result, data, message}) => {
        this.loading = false
        if(result){
          this.restrictList = data
        }else{
          this.$message({
            type: 'error',
            message: message
          }); 
        }

      })
    },
    getRestrict(uid){
      const loading = this.$notifyloading('Loading data...');
      getRestrict(uid).then(({result, data, message}) => {
        loading.close();
        if(result){
          this.formData.uid = data.uid;
          this.formData.uid2 = data.uid2;
          this.formData.restricttoAndbelow = data.restricttoAndbelow;

          this.action = 'edit';
          this.title = 'Edit restrict';
          this.dialogRestrict = true
        }else{
          this.$message({
            type: 'error',
            message: message
          }); 
        }
      })
    },
    showDialog(type, uid=''){
      if(type === 'add'){
        this.formData = {
          uid: '',
          uid2: '',
          restricttoAndbelow: 'user',
        }
        this.action = type
        this.title = 'Create restrict'
        this.dialogRestrict = true 
      }else{
        this.getRestrict(uid)
        
      }
    },
    createSubmit(){
      this.submiting = true
      delete this.formData.uid;
      createRestrict(this.formData).then(({result, message}) => {
        this.submiting = false
        if(result){
          this.dialogRestrict = false
          this.getRestrictList()
          this.$message({
            type: 'success',
            message: 'Create restrict success'
          });
        }else{
          this.$message({
            type: 'error',
            message: message
          }); 
        }
      })
    },
    updateSubmit(){
      this.submiting = true
      let uid = this.formData.uid;
      delete this.formData.uid;
      delete this.formData.uid2;
      updateRestrict(uid, this.formData).then(({result, message}) => {
        this.submiting = false
        if(result){
          this.dialogRestrict = false
          this.getRestrictList()
        }else{
          this.$message({
            type: 'error',
            message: message
          }); 
        }
      });
    },
    submitRestrict(){
      this.$refs.formRestrict.validate(valid => {
        if(valid){
          if(this.action === 'add'){
            this.createSubmit()
          }else{
            this.updateSubmit()
          }
        }
      })
    },
    deleteRestrict(uid){
      this.$confirm('Are you sure you want to delete this User restrict, Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          deleteRestrict(uid).then(({result, message}) =>{
            if(result){
              this.$notify({
                title: 'Success',
                message: `Delete restrict successfully`,
                type: 'success',
                duration: 2000
              });
              this.getRestrictList()
            }else{
              this.$message({
                type: 'error',
                message: message
              }); 
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    },
  },
  mounted(){
    this.getRestrictList()
  }
}
</script>

<style>

</style>